module.exports = __webpack_public_path__ + "img/clipboard-check.96a06444.svg";